import { ActionIcon, useMantineColorScheme } from "@mantine/core";
import { Sun, MoonStars } from "tabler-icons-react";

const ThemeButton = () => {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const dark = colorScheme === "dark";
  return (
    <ActionIcon
      onClick={() => toggleColorScheme()}
      variant="transparent"
      color={dark ? "yellow" : "blue"}
      title="Theme Button"
      size={32}
      style={{
        margin: "1em",
      }}
    >
      {dark ? <Sun size={20} /> : <MoonStars color="white" size={20} />}
    </ActionIcon>
  );
};

export default ThemeButton;
